import Image from 'next/image';
import { useContext, useEffect } from 'react';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { getImageBasePath } from 'utils/generics';
import { useRouter } from 'next/router';
import { useFetchParams } from 'hooks/useFetchParams';
import {
    SegmentEventPageTypes,
    SegmentEventNameTypes,
    SegmentEventPages,
    SegmentEventActionNames,
    SegmentEventActionTypes,
    SegmentEventButtonNames,
} from 'utils/segment/constants';
import { MPosContext } from 'utils/context';
import {
    NewPlanStages,
    policyDetailsInitState,
} from 'components/newPlan/constants';
import * as Styles from './styles';
import sendSegmentEvent from 'utils/segment';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';

interface IProps {
    message: string;
}

function Congratulations({ message }: IProps) {
    const { lob } = useFetchParams();
    const router = useRouter();
    const { setPlanDetails, setActiveStage, partnerId, userDetails } =
        useContext(MPosContext);
    const { isMobile } = useResponsiveDevice();

    useEffect(() => {
        sendSegmentEvent(
            SegmentEventNameTypes.VIEW,
            {
                page_type: SegmentEventPageTypes.CONGRATULATIONS_PAGE,
                view_name: SegmentEventPages.VIEW_CONGRATULATIONS_PAGE,
            },
            { userDetails, isMobile }
        );
    }, []);

    const goHome = () => {
        setActiveStage(NewPlanStages.MODEL);
        /**
         * Segment event
         */
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.TAP_BTN,
                action_name: SegmentEventActionNames.CLICK_GO_HOME_BUTTON,
                button_name: SegmentEventButtonNames.GO_HOME_BUTTON,
            },
            { userDetails, isMobile }
        );
        setPlanDetails(policyDetailsInitState);
        router.push(`${lob}/${partnerId}/dashboard`);
    };

    return (
        <Styles.Wrapper>
            <Styles.CongratulationImage>
                <Image
                    width={'120px'}
                    height={'120px'}
                    alt={''}
                    src={getImageBasePath('/images/congratulation.svg')}
                />
            </Styles.CongratulationImage>
            <Styles.Text>Congratulations!</Styles.Text>
            <Styles.Description>{message}</Styles.Description>
            <Styles.GoHomeButtonWrapper>
                <PrimaryButton onClick={goHome}>Go Home</PrimaryButton>
            </Styles.GoHomeButtonWrapper>
        </Styles.Wrapper>
    );
}

export default Congratulations;
